import { render, staticRenderFns } from "./OrderFileTabNav.vue?vue&type=template&id=632e2238&"
import script from "./OrderFileTabNav.vue?vue&type=script&lang=js&"
export * from "./OrderFileTabNav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports